var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"promo"}},[_c('BottomBar'),(!_vm.imgs.length)?_c('Empty',{attrs:{"loading":true}}):_vm._e(),_vm._l((_vm.imgs),function(item,index){return _c('img',{key:index,attrs:{"src":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }